/* ============================================================
   luxe-collection-toolkit.js
   Client-side chip filtering for the LUXE collection page
   (site-redesign-2026 Phase 3b). Vanilla, deferred, no deps.

   Chips live in luxe-collection-toolkit.liquid; the cards they
   filter live in the SIBLING grid section (luxe-collection-grid),
   found via the shared [data-luxe-grid-card] attribute. Filtering
   is by product tag (cards carry data-tags="tag,tag", downcased).
   Zero page reloads; count line updates via aria-live=polite.
   ============================================================ */
(function () {
  'use strict';

  function init(toolkit) {
    if (toolkit.dataset.luxeToolkitInit === 'true') return;
    toolkit.dataset.luxeToolkitInit = 'true';

    var chips = toolkit.querySelectorAll('[data-luxe-chip]');
    /* Own hook (data-luxe-ct-count) so the shared luxe-motion.js count-up
       observer, which claims every [data-luxe-count], never zeroes this line. */
    var countEl = toolkit.querySelector('[data-luxe-ct-count]');
    var prefix = countEl ? countEl.getAttribute('data-prefix') || '' : '';
    var suffix = countEl ? countEl.getAttribute('data-suffix') || '' : '';

    /* Grid cards render in the sibling grid section — query the document. */
    function cards() {
      return document.querySelectorAll('[data-luxe-grid-card]');
    }

    function setCount(n) {
      if (countEl) countEl.textContent = (prefix + ' ' + n + ' ' + suffix).trim();
    }

    function apply(tag) {
      var shown = 0;
      cards().forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split(',');
        var match = tag === 'all' || tags.indexOf(tag) !== -1;
        card.hidden = !match;
        if (match) shown++;
      });
      setCount(shown);
    }

    if (!chips.length) return;

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('luxe-ct__chip--on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply(chip.getAttribute('data-luxe-chip'));
      });
    });

    /* Initial count from the DOM so injected variant cards are included.
       Falls back to the Liquid-rendered product count when no cards found. */
    var total = cards().length;
    if (total > 0) setCount(total);
  }

  function boot() {
    document.querySelectorAll('[data-luxe-toolkit]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-init when the section reloads. */
  document.addEventListener('shopify:section:load', function (e) {
    var toolkit = e.target.querySelector('[data-luxe-toolkit]');
    if (toolkit) init(toolkit);
  });
})();
